<template>
  <layout-basic>
    <page-hero
      eyebrow="Product demonstration"
      title="Watch the 5-minute demo"
      lead="See IMPROVE in action and discover how it helps growing businesses onboard, train and develop their people."
    />

    <section class="demo-video-section">
      <v-container style="max-width: 960px">
        <demo-video
          wide
          video-key="home"
          title="Why IMPROVE Exists"
          subtitle="A short introduction from founder Steve Walker — then explore the platform."
        />
      </v-container>
    </section>

    <point-grid
      title="What you’ll see"
      :points="points"
      :columns="2"
      tint
    />

    <quote-block
      quote="IMPROVE has transformed the way we onboard and develop our people."
      attribution="IMPROVE customer"
    />

    <standard-cta
      title="Ready for the next step?"
      lead="After the demo, experience IMPROVE yourself — or buy IMPROVE when you’re ready."
    />
  </layout-basic>
</template>

<script>
import LayoutBasic from '@/layouts/Dashboard';
import PageHero from '@/components/marketing/PageHero.vue';
import PointGrid from '@/components/marketing/PointGrid.vue';
import QuoteBlock from '@/components/marketing/QuoteBlock.vue';
import StandardCta from '@/components/marketing/StandardCta.vue';
import DemoVideo from '@/components/DemoVideo.vue';

export default {
  name: 'WatchDemo',
  components: {
    LayoutBasic,
    PageHero,
    PointGrid,
    QuoteBlock,
    StandardCta,
    DemoVideo,
  },
  metaInfo() {
    return {
      title: 'Watch the 5-minute demo | IMPROVE Learning Platform',
      meta: [
        {
          name: 'description',
          content:
            'Watch the IMPROVE product demonstration. See how growing businesses onboard employees, stay compliant and develop their people.',
        },
      ],
      link: [{ rel: 'canonical', href: 'https://www.improve.online/watch-demo' }],
    };
  },
  data() {
    return {
      points: [
        'How onboarding works for every new starter',
        'How compliance training is assigned and tracked',
        'How employees learn on any device',
        'How managers save time with one platform',
        'How you upload your own policies and courses',
        'How simple annual pricing works for SMEs',
      ],
    };
  },
};
</script>
